import { connect } from 'react-redux'
import GeneratedLicenseDownload from '../../components/GeneratedLicenses/GeneratedLicenseDownload'
import { getLicenseKey } from '../../actions'

const mapDispatchToProps = (dispatch) => {
    return {
        getLicenseKey: (id) => dispatch(getLicenseKey(id))
    }
}

export default connect(null, mapDispatchToProps)(GeneratedLicenseDownload)
